import { ChakraProvider, ColorModeScript, createStandaloneToast } from '@chakra-ui/react';
import { Worker } from '@react-pdf-viewer/core';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { Router } from 'react-router';
import './index.css';
import './i18n/i18n.ts';

import App from './App';
import { getStorage, setStorage, STORAGE_KEY } from './helpers/storage';
import store from './helpers/store';
import reportWebVitals from './reportWebVitals';
import theme from './themes';
import { history } from './utils/history';

const setDefaultTheme = (defaultTheme: string) => {
  const existTheme = getStorage(STORAGE_KEY.CHAKRA_UI_COLOR_MODE);
  if (!existTheme) {
    setStorage(STORAGE_KEY.CHAKRA_UI_COLOR_MODE, defaultTheme);
  }
};

const { ToastContainer } = createStandaloneToast();

const container = document.getElementById('root');
const root = createRoot(container!);
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnReconnect: false,
      refetchOnWindowFocus: false,
      staleTime: 1000 * 60 * 1,
    },
  },
});
setDefaultTheme('dark');
root.render(
  <QueryClientProvider client={queryClient}>
    <Provider store={store}>
      <ChakraProvider theme={theme}>
        <Router history={history}>
          <Worker workerUrl='https://unpkg.com/pdfjs-dist@3.4.120/build/pdf.worker.min.js'>
            <ColorModeScript initialColorMode='dark' />
            <App />
            <ToastContainer />
          </Worker>
        </Router>
      </ChakraProvider>
    </Provider>
  </QueryClientProvider>
);

reportWebVitals();

// Register service worker
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js')
      .then((registration) => {
        console.log('SW registered: ', registration);
      })
      .catch((registrationError) => {
        console.log('SW registration failed: ', registrationError);
      });
  });
}
